import {Component, OnInit} from '@angular/core';
import {Router, Event, NavigationEnd} from '@angular/router';
import {environment} from 'environments/environment';
import {GoogleAnalyticsService} from 'ngx-google-analytics';


import {Chart, ChartOptions, ChartType} from 'chart.js';

import ChartDataLabels from 'chartjs-plugin-datalabels';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    constructor(
        private router: Router,
        protected $gaService: GoogleAnalyticsService
    ) {
        this.router.events.subscribe((event: Event) => {
            if (event instanceof NavigationEnd && environment.production) {
                this.$gaService.pageView(event.url);
            }
        });
    }
    ngOnInit(): void {
        Chart.register(ChartDataLabels);
    }
}
